import "./App.css";
import useAuth from "./App/Hooks/useAuth";
import { Fragment, useEffect } from "react";
import { Colors } from "./App/Assets/Styles/Colors";
import { createTheme, ThemeProvider } from "@mui/material";
import { Layout } from "./App/Layout/Layout";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminRoute from "./App/Routes/admin.route";
import PublicRoutes from "./App/Routes/public.route";
import CompanyRoute from "./App/Routes/company.route";
import Login from "./App/View/Auth/Login";
import { ToasterContainer } from "./App/Components/Toaster/Toaster";
import { Images } from "./App/Assets/Images/Images";

function App() {
  const { user } = useAuth();
  console.log(user, "useruser");

  const theme = createTheme({
    typography: {
      fontFamily: "Poppins, sans-serif",
      h1: {
        fontSize: "72px",
      },
      h2: {
        fontSize: "60px",
      },
      h3: {
        fontSize: "48px",
      },
      h4: {
        fontSize: "36px",
      },
      h5: {
        fontSize: "24px",
      },
      h6: {
        fontSize: "18px",
      },
      subtitle1: {
        fontSize: "20px",
      },
      subtitle2: {
        fontSize: "14px",
        fontWeight: 400,
      },
      caption: {
        fontSize: "12px",
      },
    },
    palette: {
      primary: {
        main: Colors.secondary,
      },
      secondary: {
        main: Colors.primary,
      },
    },
  });

  // useEffect(() => {
  //   console.log("Effect mounted");

    
  //   if (Notification.permission !== "granted") {
  //     Notification.requestPermission().then((perm) =>
  //       console.log("Permission Requested:", perm)
  //     );
  //   }

  //   let notificationShown = false;

  //   const showNotification = () => {
  //     console.log("Trying to show notification...");
  //     console.log("Current Permission:", Notification.permission);

  //     if (Notification.permission === "granted") {
  //       new Notification("Reminder", {
  //         body: "Please update your timesheet and log your working hours.",
  //         icon: Images.notiIcon,
  //       });
  //       console.log("Notification should have appeared.");
  //     } else {
  //       console.warn("Permission not granted for notifications.");
  //     }
  //   };

  //   const checkTime = () => {
  //     const now = new Date();
  //     const currentHour = now.getHours();

  //     if (!notificationShown && currentHour >= 18  && currentHour <= 22) {
  //       notificationShown = true;
  //       showNotification();
  //     }

  //     if (currentHour > 22) {
  //       notificationShown = false;
  //     }
  //   };

  //   const interval = setInterval(checkTime, 1000);
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <Fragment>
      <ThemeProvider theme={theme}>
        <ToasterContainer />
        <BrowserRouter>
          <Routes>
            <Route
              path="/login"
              element={
                user ? (
                  user.role == "company" ? (
                    <Navigate to="/dashboard" />
                  ) : user.role == "admin" ? (
                    <Navigate to="/createcompany" />
                  ) : (
                    <Navigate to="/timesheet" />
                  )
                ) : (
                  <Login />
                )
              }
            />

            <Route
              path="/"
              element={
                user ? (
                  user.role == "company" ? (
                    <Navigate to="/dashboard" />
                  ) : user.role == "admin" ? (
                    <Navigate to="/createcompany" />
                  ) : (
                    <Navigate to="/timesheet" />
                  )
                ) : (
                  <Navigate to="/login" />
                )
              }
            />

            <Route element={user ? <Layout /> : <Navigate to={"/login"} />}>
              {AdminRoute.map((route, i) => (
                <Route key={i} path={route.path} element={route.component} />
              ))}
            </Route>

            <Route element={user ? <Layout /> : <Navigate to={"/login"} />}>
              {PublicRoutes.map((route, i) => (
                <Route key={i} path={route.path} element={route.component} />
              ))}
            </Route>
            <Route element={user ? <Layout /> : <Navigate to={"/login"} />}>
              {CompanyRoute.map((route, i) => (
                <Route key={i} path={route.path} element={route.component} />
              ))}
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Fragment>
  );
}

export default App;
